var $ = global.jQuery = global.$;
require('jquery-ui/datepicker');
require('jquery-ui/themes/base/jquery.ui.datepicker.css');
require('jquery-ui/themes/base/jquery-ui.css');
require('jquery-ui/themes/flick/jquery.ui.theme.css');
var widgets = require('../lib/widgets');

var Field = require('./Field');

var DateField = Field.extend({
  init: function() {
    var self = this;
    this._super();
    this.$input.datepicker({
      dateFormat: self.$input.data('dateFormat'),
      minDate: 0,
      changeMonth: true,
      changeYear: true,
      showButtonPanel: true,
      hideIfNoPrevNext: true,
      onClose: function(dateText, inst) {
        function isDonePressed() {
          return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
        }

        if (isDonePressed()) {
          var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
          var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
          $(this).datepicker('setDate', new Date(year, month, 1)).trigger('change');

          $('.date-picker').focusout(); //Added to remove focus from datepicker input box on selecting date
        }
      },
      beforeShow: function(input, inst) {

        inst.dpDiv.addClass('month-year-datepicker');

        $(document).unbind('mousedown', $.datepicker._checkExternalClick);

        if ((datestr = $(this).val()).length > 0) {
          year = datestr.substring(datestr.length - 4, datestr.length);
          month = datestr.substring(0, 2);
          $(this).datepicker('option', 'defaultDate', new Date(year, month - 1, 1));
          $(this).datepicker('setDate', new Date(year, month - 1, 1));
          $(".ui-datepicker-calendar").hide();
        }
      }
    });
  },
});

module.exports = DateField;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/DateField.js
// module id = 25
// module chunks = 0